import { Link } from 'react-router-dom';
import { Heart, Award, Users, Sparkles, ArrowRight } from 'lucide-react';
import Reveal from '../components/Reveal';
import { stats } from '../data/sampleContent';

const values = [
  { icon: Heart, title: 'Passion', text: 'We pour heart into every celebration, big or small.' },
  { icon: Award, title: 'Excellence', text: 'Detail-obsessed planning and flawless execution.' },
  { icon: Users, title: 'Partnership', text: 'Your vision leads — we make it effortless to achieve.' },
  { icon: Sparkles, title: 'Creativity', text: 'Bespoke themes that turn moments into stories.' },
];

export default function About() {
  return (
    <div className="section py-12">
      <Reveal className="mx-auto max-w-3xl text-center">
        <h1 className="font-display text-4xl font-extrabold">We Are <span className="text-gradient">Event Story</span></h1>
        <p className="mt-4 text-lg text-ink-300">
          For over eight years we've been crafting unforgettable experiences — from
          intimate gatherings to grand productions. We blend creativity, technology
          and meticulous planning so you can simply enjoy the moment.
        </p>
      </Reveal>

      <div className="my-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08} className="glass p-6 text-center">
            <p className="font-display text-3xl font-extrabold text-gradient">{s.value}</p>
            <p className="mt-1 text-sm text-ink-300">{s.label}</p>
          </Reveal>
        ))}
      </div>

      <Reveal className="mb-8 text-center">
        <h2 className="font-display text-3xl font-bold">Our Values</h2>
      </Reveal>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {values.map((v, i) => (
          <Reveal key={v.title} delay={i * 0.08} className="glass p-6">
            <span className="mb-4 grid h-12 w-12 place-items-center rounded-xl bg-brand-gradient text-white">
              <v.icon size={22} />
            </span>
            <h3 className="font-display text-lg font-bold">{v.title}</h3>
            <p className="mt-2 text-sm text-ink-300">{v.text}</p>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-16 text-center">
        <Link to="/customize" className="btn-primary">
          Plan Your Event <ArrowRight size={18} />
        </Link>
      </Reveal>
    </div>
  );
}
